import { useRef, useState, useEffect, Fragment } from "react";
import { Spinner } from "react-bootstrap";
import {
  faCheck,
  faTimes,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./local.css";
import axios from "axios";

const baseURL = process.env.REACT_APP_API;
const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;
const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
const REGISTER_URL = baseURL + "auth/users/";

const Register = () => {
  const userRef = useRef();
  const errRef = useRef();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState("");
  const [validName, setValidName] = useState(false);
  const [userFocus, setUserFocus] = useState(false);

  const [email, setEmail] = useState("");
  const [validEmail, setValidEmail] = useState(false);
  const [emailFocus, setEmailFocus] = useState(false);
  const [matchEmail, setMatchEmail] = useState("");
  const [validEmailMatch, setValidEmailMatch] = useState(false);
  const [matchEmailFocus, setMatchEmailFocus] = useState(false);

  const [pwd, setPwd] = useState("");
  const [validPwd, setValidPwd] = useState(false);
  const [pwdFocus, setPwdFocus] = useState(false);

  const [matchPwd, setMatchPwd] = useState("");
  const [validPassMatch, setValidPassMatch] = useState(false);
  const [matchPassFocus, setMatchPassFocus] = useState(false);

  const [errMsg, setErrMsg] = useState("");
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    userRef.current.focus();
    document.body.classList.add("accountBodyColor");

    // Clean up function to remove the class when the component unmounts
    return () => {
      document.body.classList.remove("accountBodyColor");
    };
  }, []);

  useEffect(() => {
    setValidName(validateIdNumber(user));
  }, [user]);

  useEffect(() => {
    setValidEmail(EMAIL_REGEX.test(email));
    setValidEmailMatch(email === matchEmail);
  }, [email, matchEmail]);

  useEffect(() => {
    setValidPwd(PWD_REGEX.test(pwd));
    setValidPassMatch(pwd === matchPwd);
  }, [pwd, matchPwd]);

  useEffect(() => {
    setErrMsg("");
  }, [user, email, matchEmail, pwd, matchPwd]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let errorMessage = "";
    const v1 = validateIdNumber(user);
    const v2 = PWD_REGEX.test(pwd);
    const v3 = EMAIL_REGEX.test(email);
    const newUser = {
      username: user,
      password: pwd,
      email: email,
    };
    if (!v1 || !v2 || !v3) {
      setErrMsg("Invalid Entry");
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(REGISTER_URL, newUser);
      setSuccess(true);
      setLoading(false);
      setUser("");
      setPwd("");
      setMatchPwd("");
    } catch (err) {
      if (
        err?.response?.data?.password &&
        err?.response?.data?.password.length > 0
      ) {
        errorMessage += err.response.data.password[0];
      }
      if (err?.response?.data?.email && err?.response?.data?.email.length > 0) {
        if (errorMessage) {
          errorMessage += "\n";
        }
        errorMessage += err.response.data.email[0];
      }
      if (
        err?.response?.data?.username &&
        err?.response?.data?.username.length > 0
      ) {
        if (errorMessage) {
          errorMessage += "\n";
        }
        errorMessage += err.response.data.username[0];
      }
      setErrMsg(errorMessage);
      setLoading(false);
      errRef.current.focus();
    }
  };

  const validateIdNumber = (id) => {
    if (id.length !== 9) return false;
    id = String(id).trim();
    if (id.length > 9 || isNaN(id)) return false;
    id = id.length < 9 ? ("00000000" + id).slice(-9) : id;
    return (
      Array.from(id, Number).reduce((counter, digit, i) => {
        const step = digit * ((i % 2) + 1);
        return counter + (step > 9 ? step - 9 : step);
      }) %
      10 ===
      0
    );
  };

  if (loading) {
    return (
      <Fragment>
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <div className="text-center">
            <Spinner animation="border" variant="danger" visible />
            <br />
            <br />
            <h3 className="spinnerText">המתן עד סיום הפעולה.</h3>
          </div>
        </div>
      </Fragment>
    );
  } else {
    return (
      <Fragment
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <center>

          {success ? (
            <section>
              <h1>התהליך עבר בהצלחה</h1>
              <h1>
                הקישור להפעלת המשתמש נשלח אליכם למייל. לא מצאתם אותו? כדאי לבדוק
                בתיקיית הספאם (דואר זבל)."{" "}
              </h1>
              <p>
                +++
                <a href="#">כניסה</a>
              </p>
            </section>
          ) : (
            <section>
              <p
                ref={errRef}
                className={errMsg ? "errmsg" : "hide"}
                aria-live="assertive"
              >
                {errMsg}
              </p>
              <h1>הרשמה</h1>
              <label>
                אם השתתפת במכרז קודם, סביר להניח שפרטיך כבר רשומים במערכת – כל שעליך לעשות הוא <br /> <a href="/resetpassword"  > לאפס את הסיסמה.</a>
              </label>
              <br />
              <form className="accountForm" onSubmit={handleSubmit}>
                <label htmlFor="username">
                  שם משתמש:
                  <FontAwesomeIcon
                    icon={faCheck}
                    className={validName ? "valid" : "hide"}
                  />
                  <FontAwesomeIcon
                    icon={faTimes}
                    className={validName || !user ? "hide" : "invalid"}
                  />
                </label>
                <input
                  type="text"
                  id="username"
                  ref={userRef}
                  autoComplete="off"
                  onChange={(e) => setUser(e.target.value)}
                  value={user}
                  required
                  aria-invalid={validName ? "false" : "true"}
                  aria-describedby="uidnote"
                  onFocus={() => setUserFocus(true)}
                  onBlur={() => setUserFocus(false)}
                  placeholder="מספר תעודת זהות 9 ספרות"
                />
                <p
                  id="uidnote"
                  className={
                    userFocus && user && !validName ? "instructions" : "hide"
                  }
                >
                  <FontAwesomeIcon icon={faInfoCircle} />
                  הזן את מספר תעודת הזהות שלך. 9 ספרות כולל אפסים מובילים
                </p>

                <label htmlFor="email">
                  דואר אלקטרוני:
                  <FontAwesomeIcon
                    icon={faCheck}
                    className={validEmail ? "valid" : "hide"}
                  />
                  <FontAwesomeIcon
                    icon={faTimes}
                    className={validEmail || !email ? "hide" : "invalid"}
                  />
                </label>
                <input
                  type="email"
                  id="email"
                  autoComplete="off"
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  required
                  aria-invalid={validEmail ? "false" : "true"}
                  aria-describedby="uidnote"
                  onFocus={() => setEmailFocus(true)}
                  onBlur={() => setEmailFocus(false)}
                />
                <p
                  id="uidnote"
                  className={
                    emailFocus && email && !validEmail ? "instructions" : "hide"
                  }
                >
                  <FontAwesomeIcon icon={faInfoCircle} />
                  דואר אלקטרוני תקין כמו a@a.com
                </p>

                <label htmlFor="confirm_pwd">
                  אימות כתובת דואר אלקטרוני:
                  <FontAwesomeIcon
                    icon={faCheck}
                    className={validEmailMatch && matchEmail ? "valid" : "hide"}
                  />
                  <FontAwesomeIcon
                    icon={faTimes}
                    className={
                      validEmailMatch || !matchEmail ? "hide" : "invalid"
                    }
                  />
                </label>
                <input
                  type="email"
                  id="confirm_email"
                  autoComplete="off"
                  onChange={(e) => setMatchEmail(e.target.value)}
                  value={matchEmail}
                  required
                  aria-invalid={validEmailMatch ? "false" : "true"}
                  aria-describedby="confirmnote"
                  onFocus={() => setMatchEmailFocus(true)}
                  onBlur={() => setMatchEmailFocus(false)}
                />

                <p
                  id="confirmnote"
                  className={
                    matchEmailFocus && !validEmailMatch
                      ? "instructions"
                      : "hide"
                  }
                >
                  <FontAwesomeIcon icon={faInfoCircle} />
                  שתי כתובות הדואר האלקטרוני צריכות להיות זהות.
                </p>

                <label htmlFor="password">
                  סיסמה:
                  <FontAwesomeIcon
                    icon={faCheck}
                    className={validPwd ? "valid" : "hide"}
                  />
                  <FontAwesomeIcon
                    icon={faTimes}
                    className={validPwd || !pwd ? "hide" : "invalid"}
                  />
                </label>
                <input
                  type="password"
                  id="password"
                  onChange={(e) => setPwd(e.target.value)}
                  value={pwd}
                  required
                  aria-invalid={validPwd ? "false" : "true"}
                  aria-describedby="pwdnote"
                  onFocus={() => setPwdFocus(true)}
                  onBlur={() => setPwdFocus(false)}
                />
                <p
                  id="pwdnote"
                  className={pwdFocus && !validPwd ? "instructions" : "hide"}
                >
                  <FontAwesomeIcon icon={faInfoCircle} />
                  8 עד 24 תוים.
                  <br />
                  צריך להכיל אותיות גדולות וקטנות באנגלית, מספרים ותו מיוחד.
                  <br />
                  תוים מיוחדים מותרים:{" "}
                  <span aria-label="exclamation mark">!</span>{" "}
                  <span aria-label="at symbol">@</span>{" "}
                  <span aria-label="hashtag">#</span>{" "}
                  <span aria-label="dollar sign">$</span>{" "}
                  <span aria-label="percent">%</span>
                  <br />
                  <label>
                    אסור שהסיסמה תהיה דומה לדואר האלקטרוני או לשם המשתמש.
                  </label>
                </p>

                <label htmlFor="confirm_pwd">
                  אימות סיסמה:
                  <FontAwesomeIcon
                    icon={faCheck}
                    className={validPassMatch && matchPwd ? "valid" : "hide"}
                  />
                  <FontAwesomeIcon
                    icon={faTimes}
                    className={validPassMatch || !matchPwd ? "hide" : "invalid"}
                  />
                </label>
                <input
                  type="password"
                  id="confirm_pwd"
                  onChange={(e) => setMatchPwd(e.target.value)}
                  value={matchPwd}
                  required
                  aria-invalid={validPassMatch ? "false" : "true"}
                  aria-describedby="confirmnote"
                  onFocus={() => setMatchPassFocus(true)}
                  onBlur={() => setMatchPassFocus(false)}
                />
                <p
                  id="confirmnote"
                  className={
                    matchPassFocus && !validPassMatch ? "instructions" : "hide"
                  }
                >
                  <FontAwesomeIcon icon={faInfoCircle} />
                  שתי הסיסמאות צריכות להיות זהות.
                </p>

                <button
                  disabled={
                    !validName ||
                      !validEmail ||
                      !validEmailMatch ||
                      !validPwd ||
                      !validPassMatch
                      ? true
                      : false
                  }
                >
                  הרשמה
                </button>
              </form>
              <p>
                <label>נרשמת בעבר?</label>
                <br />
                <span className="line">
                  {/*put router link here*/}
                  <a href={process.env.REACT_APP_URL + "login"}>כניסה</a>
                </span>
              </p>
            </section>
          )}
        </center>
      </Fragment>
    );
  }
};

export default Register;
